export const budgetItemTypes = [
  {value: 18, label: 'Capacity building'},
  {value: 15, label: 'Drinking water'},
  {value: 5, label: 'Employment'},
  {value: 17, label: 'Hygiene education'},
  {value: 44, label: 'Knowledge & research'},
  {value: 43, label: 'Lobbying & advocacy'},
  {value: 4, label: 'Maintenance'},
  {value: 8, label: 'Management'},
  {value: 39, label: 'Monitoring & evaluation'},
  {value: 40, label: 'Office costs'},
  {value: 38, label: 'Other'},
  {value: 12, label: 'PR & marketing'},
  {value: 16, label: 'Sanitation'},
  {value: 41, label: 'Staff costs'},
  {value: 14, label: 'Total'},
  {value: 7, label: 'Training'},
  {value: 10, label: 'Transportation / logistics'},
  {value: 42, label: 'Water resource management'}
]

export const resultTypes = [
  { label: 'output', value: '1' },
  { label: 'outcome', value: '2' },
  { label: 'impact', value: '3' },
  { label: 'other', value: '9' }
]

export const indicatorTypes = [
  { label: 'quantitative', value: 1},
  { label: 'qualitative', value: 2}
]

export const measureType = {
  UNIT: '1',
  PERCENTAGE: '2',
}

export const indicatorType = {
  QUANTITATIVE: 1,
  QUALITATIVE: 2,
}

export const statusUpdate = {
  D: 'Draft',
  P: 'Pending Approval',
  R: 'Declined',
  A: 'Approved'
}

export const ACTIVE_PERIOD = 'active-period'

export const statusDescription = {
  [ACTIVE_PERIOD]: 'Active',
  D: 'Draft update created',
  P: 'Update submitted',
  R: 'Update declined',
  A: 'Approved update reported',
  NO_STATUS: 'No status yet'
}
